<template>
  <div class="query-form">
    <a-row type="flex" style="width: 100%;">
      <a-col :sm="24" :md="24" :lg="6" :xl="6">
        
        <a-button-group style=" margin:8px 0 8px 0">
          <a-button @click="toggleType('')" >全部</a-button>
          <a-button @click="toggleType('WARNING')">已支付</a-button>
          <a-button @click="toggleType('INFORMATION')">待支付</a-button>
        </a-button-group>
      </a-col>
      <a-col :sm="24" :md="24" :lg="18" :xl="18">
        <!-- 关键词搜索 -->
        <div class="search-keyword">
          <a-input placeholder="输入关键字搜索" v-model="blurry" style="margin: 0 20px;" @pressEnter="blurrySearch"></a-input>
          <a-button type="primary" icon="search"  @click="blurrySearch">搜索</a-button>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      blurry:''
    }
  },
  methods:{
    /**
     * 类型企业换
     */
    toggleType(type){
      // console.log('type',type)
    },
    /**
     * 模糊搜索
     */
    blurrySearch() {
      this.$emit('blurrySearch',this.blurry)
    },
  }
}
</script>

<style lang='less' scope>
.query-form {
  padding: 16px;
  overflow: hidden;
  padding-bottom: 15px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .search-keyword {
    max-width: 500px;
    width: 57%;
    min-width: 400px;
    float: left;
    margin: 8px 20px  8px 0;
    display: flex;
    align-items: center;
    .ant-input {margin-right: 10px;}
  }
}
</style>